// extracted by mini-css-extract-plugin
module.exports = {"btnConfirm":"styles_btnConfirm__2b88Z"};